import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Navigation = ({ activeSection }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = ['Home', 'About', 'Projects', 'Contact'];

  return (
    <nav className="navigation">
      <div className="nav-container">
        {/* Logo removed as requested */}

        <div className="nav-menu">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item.toLowerCase())}
              className={`nav-item ${activeSection === item.toLowerCase() ? 'active' : ''
                }`}
            >
              {item}
            </button>
          ))}
        </div>

        <button
          className="theme-toggle-btn"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>
      </div>
    </nav>
  );
};

export default Navigation;